import { AlertTriangle } from 'react-feather'
import { Button, Typography } from '@mui/material'
import theme from 'src/styles/theme'
import styled from 'styled-components'
import { ButtonMui } from 'src/components/ButtonMui'

export const ReturnButton = styled(Button)`
  background: ${theme.colors.confirm} !important;
`

export const WarningIcon = styled(AlertTriangle)`
  color: ${theme.colors.red2};
`

export const WarningTitle = styled(Typography)`
  color: ${theme.colors.red2};
`

export const WarningDescription = styled(Typography)`
  max-width: 400px;
  word-wrap: break-word;
  text-align: center;
`

export const ContainerResend = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 10px;
`

export const ButtonResend = styled(ButtonMui)`
    background: ${theme.colors.blue} !important;
    height: 30px;
`

export const Container = styled.div`
  min-height: 8rem;
  max-height: 15rem;
  overflow-y: scroll;
  scroll-behavior: smooth;
`
